import axios from '../axios'

// フィードバック一覧（生徒は自分の分）
const getFeedbackApi = async () => {
  return await axios.get('api/lms/feedback')
}

export default getFeedbackApi
